/**
 * Automation Constants
 *
 * This file re-exports from the dynamic event-entity mapping system.
 * To add new events, edit event-entity-map.js instead of this file.
 */

import {
  generateAutomationsMap,
  getAutomationRuleEvents as getResolvedAutomationRuleEvents,
} from './event-entity-map';
import { resolveAutomationConfig } from './extension-registry';
import AutomationAiMessageInput from './components/AutomationAiMessageInput.vue';
import AutomationKanbanStageInput from './components/AutomationKanbanStageInput.vue';
import AutomationKanbanFunnelInput from './components/AutomationKanbanFunnelInput.vue';

export const getAutomations = () => generateAutomationsMap();

export const getAutomationRuleEvents = () => getResolvedAutomationRuleEvents();

// Action types remain static (UI metadata)
export const BASE_AUTOMATION_ACTION_TYPES = [
  {
    key: 'delay_next_action',
    label: 'DELAY_NEXT_ACTION',
    inputType: 'delay_duration',
  },
  {
    key: 'delay_next_action_range',
    label: 'DELAY_NEXT_ACTION_RANGE',
    inputType: 'delay_duration_range',
  },
  {
    key: 'assign_agent',
    label: 'ASSIGN_AGENT',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'ASSIGN_TEAM',
    inputType: 'search_select',
  },
  {
    key: 'add_label',
    label: 'ADD_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'remove_label',
    label: 'REMOVE_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'send_email_to_team',
    label: 'SEND_EMAIL_TO_TEAM',
    inputType: 'team_message',
  },
  {
    key: 'send_email_transcript',
    label: 'SEND_EMAIL_TRANSCRIPT',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'MUTE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'SNOOZE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'RESOLVE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'open_conversation',
    label: 'OPEN_CONVERSATION',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'SEND_WEBHOOK_EVENT',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'SEND_ATTACHMENT',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'SEND_MESSAGE',
    inputType: 'textarea',
  },
  {
    key: 'send_message_with_ai',
    label: 'SEND_MESSAGE_WITH_AI',
    inputType: 'custom_component',
    component: AutomationAiMessageInput,
  },
  {
    key: 'move_to_kanban_stage',
    label: 'MOVE_TO_KANBAN_STAGE',
    inputType: 'custom_component',
    component: AutomationKanbanStageInput,
  },
  {
    key: 'move_to_kanban_funnel',
    label: 'MOVE_TO_KANBAN_FUNNEL',
    inputType: 'custom_component',
    component: AutomationKanbanFunnelInput,
  },
  {
    key: 'add_private_note',
    label: 'ADD_PRIVATE_NOTE',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'CHANGE_PRIORITY',
    inputType: 'search_select',
    optionsSource: 'priority_options',
  },
];

export const getAutomationActionTypes = () => {
  const resolvedConfig = resolveAutomationConfig({
    actionTypes: BASE_AUTOMATION_ACTION_TYPES,
  });

  return resolvedConfig.actionTypes || BASE_AUTOMATION_ACTION_TYPES;
};
